import { memo } from 'react';
import { Box, HStack } from '@chakra-ui/react';

/**
 * A decorative arrow component used to show directional flow between entities
 */
export const ConnectionArrow = memo((): JSX.Element => {
  return (
    <HStack spacing={0} align="center" mx="16px" flexShrink={0}>
      <Box w="110px" h="2px" bg="gray.400" />
      <Box position="relative" w="6px" h="12px" ml="-4px">
        <Box
          position="absolute"
          top="0"
          left="0"
          w="8px"
          h="2px"
          bg="gray.400"
          transformOrigin="left center"
          transform="rotate(45deg)"
        />
        <Box
          position="absolute"
          bottom="0"
          left="0"
          w="8px"
          h="2px"
          bg="gray.400"
          transformOrigin="left center"
          transform="rotate(-45deg)"
        />
      </Box>
    </HStack>
  );
});

ConnectionArrow.displayName = 'ConnectionArrow';
